import React from 'react';
import Icon from '../../../components/AppIcon';

const RevenueKPICards = () => {
  const kpiData = [
    {
      id: 1,
      title: 'Total Revenue',
      value: '$2,847,392',
      change: '+12.5%',
      changeType: 'positive',
      icon: 'IndianRupee',
      sparklineData: [45, 52, 48, 61, 58, 67, 72],
      description: 'Monthly recurring revenue',
    },
    {
      id: 2,
      title: 'Commission Earnings',
      value: '$426,109',
      change: '+8.3%',
      changeType: 'positive',
      icon: 'Percent',
      sparklineData: [32, 38, 35, 42, 39, 45, 48],
      description: 'Platform commission revenue',
    },
    {
      id: 3,
      title: 'Payout Amount',
      value: '$2,421,283',
      change: '+11.2%',
      changeType: 'positive',
      icon: 'ArrowUpRight',
      sparklineData: [78, 82, 79, 85, 83, 89, 92],
      description: 'Partner payouts processed',
    },
    {
      id: 4,
      title: 'Profit Margin',
      value: '14.96%',
      change: '-0.8%',
      changeType: 'negative',
      icon: 'TrendingUp',
      sparklineData: [15.2, 15.8, 15.1, 14.9, 15.3, 14.7, 14.96],
      description: 'Net profit percentage',
    },
  ];

  const renderSparkline = (data) => {
    const max = Math.max(...data);
    const min = Math.min(...data);
    const range = max - min;

    const points = data
      ?.map((value, index) => {
        const x = (index / (data?.length - 1)) * 60;
        const y = 20 - ((value - min) / range) * 20;
        return `${x},${y}`;
      })
      ?.join(' ');

    return (
      <svg width='60' height='20' className='opacity-60'>
        <polyline
          points={points}
          fill='none'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    );
  };

  return (
    <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 mb-8'>
      {kpiData?.map((kpi) => (
        <div
          key={kpi?.id}
          className='bg-card border border-border rounded-lg p-6 elevation-1'
        >
          <div className='flex items-center justify-between mb-4'>
            <div
              className={`p-2 rounded-lg ${
                kpi?.changeType === 'positive' ? 'bg-success/10' : 'bg-error/10'
              }`}
            >
              <Icon
                name={kpi?.icon}
                size={20}
                className={
                  kpi?.changeType === 'positive' ? 'text-success' : 'text-error'
                }
              />
            </div>
            <div className='text-right'>
              {renderSparkline(kpi?.sparklineData)}
            </div>
          </div>

          <div className='space-y-2'>
            <h3 className='text-sm font-medium text-muted-foreground'>
              {kpi?.title}
            </h3>
            <div className='flex items-end justify-between'>
              <span className='text-2xl font-bold text-foreground'>
                {kpi?.value}
              </span>
              <span
                className={`text-sm font-medium ${
                  kpi?.changeType === 'positive' ? 'text-success' : 'text-error'
                }`}
              >
                {kpi?.change}
              </span>
            </div>
            <p className='text-xs text-muted-foreground'>{kpi?.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default RevenueKPICards;
